import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialState } from "./types";
import { reducers } from "./reducers";
import { getWorkplacesThunk } from "./asyncthunk";

const initialState: IInitialState = {
  loading: false,
  error: null,
  workplacesList: [],
  onboardingTimeout:
    typeof window !== "undefined"
      ? sessionStorage.getItem("onboarding_timeout")
      : null,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: reducers,
  extraReducers: (builder) => {
    builder.addCase(
      getWorkplacesThunk.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.workplacesList = action.payload;
      },
    );
  },
});

export const { setOnboardingTimeout } = AuthSlice.actions;
export const selectWorkplacesList = (state: any) =>
  state.authReducer.workplacesList;
export const selectOnboardingTimeout = (state: any) =>
  state.authReducer.onboardingTimeout;

export default AuthSlice.reducer;
